import script from "./CollectivitesFormView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectivitesFormView.vue?vue&type=script&setup=true&lang=ts"

import "./CollectivitesFormView.vue?vue&type=style&index=0&id=7c0623d9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c0623d9"]])

export default __exports__